module.exports = __webpack_public_path__ + "img/banner_creator.99c99bf4.png";